import { render, staticRenderFns } from "./CreateQuiz.vue?vue&type=template&id=3fc928a8"
import script from "./CreateQuiz.vue?vue&type=script&lang=js"
export * from "./CreateQuiz.vue?vue&type=script&lang=js"
import style0 from "./CreateQuiz.vue?vue&type=style&index=0&id=3fc928a8&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./CreateQuiz.vue?vue&type=style&index=2&id=3fc928a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports